import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
} from "class-validator"
import dayjs from "dayjs"

export function IsOnlyOneFilled(
  property: string,
  validationOptions?: ValidationOptions,
) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isOnlyOneFilled",
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [property],
      validator: {
        validate(value: any, args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints
          const relatedValue = (args.object as any)[relatedPropertyName]

          // Validation passes if either the current property or the related property is filled
          const isCurrentFilled = value !== null && value !== ""
          const isRelatedFilled = relatedValue !== null && relatedValue !== ""

          return isCurrentFilled || isRelatedFilled
        },
        defaultMessage(args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints
          return `Either ${args.property} or ${relatedPropertyName} must be filled`
        },
      },
    })
  }
}

export function IsRelatedDateAfter(
  constraints: string,
  validationOptions?: ValidationOptions,
) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isDateAfter",
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [constraints],
      validator: {
        validate(value: any, args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints
          const relatedValue = (args.object as any)[relatedPropertyName]

          // Validation passes if the related date is after the current date
          if (!value || !relatedValue) {
            return true // Skip validation if either date is not provided
          }

          const currentDate = dayjs(value).endOf("day")
          const relatedDate = dayjs(relatedValue).endOf("day")

          return currentDate.isAfter(relatedDate)
        },
        defaultMessage(args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints
          return `${args.property} is not after ${relatedPropertyName}`
        },
      },
    })
  }
}

export function IsDateAfter(date: Date, validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isDateAfterToday",
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: any, args: ValidationArguments) {
          // Validation passes if the related date is after the current date
          if (!value) {
            return true // Skip validation if either date is not provided
          }
          const currentDate = new Date(value)

          return date <= currentDate
        },
        defaultMessage(args: ValidationArguments) {
          return `${args.property} is not after today`
        },
      },
    })
  }
}
